module.exports = __webpack_public_path__ + "img/info_relleno_azul.dd4f7354.svg";